import React from 'react';
import './StartScreen.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageLayout from './common/PageLayout.js';

function StartScreen() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const navigationProps = {
        showPrevious: false,
        showNext: false,
        align: 'center'
    };

    return (
        <PageLayout navigationProps={navigationProps}>
            <div className="start-screen">
                

                <div className="start-hero-icon">
                    <span role="img" aria-label="bank" style={{ fontSize: '36px' }}>🏛️</span>
                </div>

                <div className="start-header">
                    <h1>{t('startHeaderTitle')}</h1>
                    <h2 className="start-header-subtitle">{t('startHeaderSubtitle')}</h2>
                    <p>{t('startHeaderDesc')}</p>
                </div>

                <div className="start-features">
                    <div className="feature-card">
                        <div className="feature-icon-bg feature-icon-yellow">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 2L4.09 12.6C3.74 13.01 3.54 13.5 3.54 14H12L11 22L19.91 11.4C20.26 10.99 20.46 10.5 20.46 10H12L13 2Z" fill="#E5A100"/>
                            </svg>
                        </div>
                        <div className="feature-title">{t('startFeaturesInstantPaymentsTitle')}</div>
                        <div className="feature-desc">{t('startFeaturesInstantPaymentsDesc')}</div>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon-bg feature-icon-blue">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM18 11.09C18 15.09 15.45 18.79 12 19.92C8.55 18.79 6 15.1 6 11.09V6.39L12 4.14L18 6.39V11.09Z" fill="#3B82F6"/>
                            </svg>
                        </div>
                        <div className="feature-title">{t('startFeaturesBankSecurityTitle')}</div>
                        <div className="feature-desc">{t('startFeaturesBankSecurityDesc')}</div>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon-bg feature-icon-green">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z" fill="#059669"/>
                            </svg>
                        </div>
                        <div className="feature-title">{t('startFeaturesDirectConnectionTitle')}</div>
                        <div className="feature-desc">{t('startFeaturesDirectConnectionDesc')}</div>
                    </div>
                </div>

                <div className="start-how-it-works">
                    <div className="how-it-works-title">{t('startHowItWorksTitle')}</div>
                    <div className="how-it-works-steps">
                        <div className="step-item">
                            <div className="step-number">1</div>
                            <div className="step-label">{t('startStep1Title')}</div>
                            <div className="step-desc">{t('startStep1Desc')}</div>
                        </div>
                        <div className="step-item">
                            <div className="step-number">2</div>
                            <div className="step-label">{t('startStep2Title')}</div>
                            <div className="step-desc">{t('startStep2Desc')}</div>
                        </div>
                        <div className="step-item">
                            <div className="step-number">3</div>
                            <div className="step-label">{t('startStep3Title')}</div>
                            <div className="step-desc">{t('startStep3Desc')}</div>
                        </div>
                    </div>
                </div>

                <div className="start-support-footer">
                    {t('startSupportText')} <strong>{t('startSupportEmail')}</strong>
                </div>
                <div className="start-top-bar">
                    <button className="start-install-btn" onClick={() => navigate('/kyc')}>
                        {t('startCtaInstall')}
                    </button>
                </div>
            </div>
        </PageLayout>
    );
}

export default StartScreen;
